import React   from 'react';
import {Edit ,ArrayInput ,SimpleFormIterator, ReferenceInput ,RadioButtonGroupInput ,
    CheckboxGroupInput, SelectInput, TextInput,TabbedForm ,FormTab , email , number ,Toolbar, SaveButton, DeleteButton, ReferenceArrayInput, BooleanInput, DateInput, maxLength, useRecordContext} 
from "react-admin";
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import { useInput , required } from 'react-admin';
import { ReferenceImageInput, transformReferenceImage } from '../util/referenceImageHelper';
import { Actions, Resources, useHasPermissions } from '../lib/react-admin-loopback';
import styled from '@emotion/styled';
import { toPriceKRW } from '../util/CommonUtils';

// 1라인에 필드 배치
const useStyles = makeStyles({
    inlineBlock: { display: 'inline-flex', marginRight: '1rem' },
    inlineBlock2: { display: 'inline-flex', marginRight: '1rem' , flexGrow :3 },
    marginRight : {marginRight: '1rem'},
    table: {
        minWidth: 100,
      },
    cardtitle: {
        fontSize: 14,
      },
    cardlayout : {
        marginBottom : '20px' 
    } ,
    arrinput : {
        paddingTop : '20px'
    } ,
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
});

const CustomToolbar = props => (
    <Toolbar {...props} classes={useStyles()}>
        {props.hasEditPermission && <SaveButton />}
        {props.hasDeletePermission && <DeleteButton undoable={false} />}
    </Toolbar>
);

const validateOnSubmit = (values) => {
    const errors = {};
    
    if (values.curation) {
        if (values.serviceTime.length == 0) {
            errors.serviceTime = ['큐레이션 On 인 경우, 필수 입니다.'];
        }
        if (!values.curationAge) {
            errors.curationAge = ['큐레이션 On 인 경우, 주요 연령대가 필수 입니다.'];
        }
        if (!values.curationGenderId) {
            errors.curationGenderId = ['큐레이션 On 인 경우, 남녀 구성비가 필수 입니다.'];
        }
    }
    
    return {errors}
};

const subValidate = (value, allValues) => {
    if (allValues.curation) {
        if (!value) {
            return '큐레이션 On 인 경우, 필수 조건 입니다.'
        }
    }
    return [];
};

const transform = data => {
    console.log('MenuEdit.transform] ' + JSON.stringify(data))
    return data;
}

export const CustomerEdit = props => {

  const hasReadPermission = useHasPermissions(
    Resources.Customer,
    Actions.Show,
    () =>{
      alert('권한이 없습니다. ');
      props.history.push('/customers');
    }
  );

  const hasEditPermission = useHasPermissions(
    Resources.Customer,
    Actions.Edit,
  );

  const hasDeletePermission = useHasPermissions(
    Resources.Customer,
    Actions.Delete,
  );

    const classes = useStyles();
    
    // 입력값 Validate
    const validateEmail = [required('필수 입력'), email('이메일 형식으로 입력해 주세요')];
    const validateNumber = number('숫자 형식으로 입력해 주세요');
    const validateInput= [required('필수 입력')];
    const validateBiz = [required('필수 입력'), number('숫자만 입력해 주세요')];
    const validateChoice = subValidate ; 
    const validateType = [number('숫자 형식으로 입력해 주세요') , subValidate] ;

    const BoundedTextField = props => {
        const {
            input: { name, onChange, defaultValue, ...rest },
            meta: { touched, error },
            isRequired
        } = useInput(props);
        
        return (
            <TextField
                name={name}
                label={props.label}
                onChange={onChange}
                error={!!(touched && error)}
                helperText={touched && error}
                required={isRequired}
                defaultValue={defaultValue}
                
                {...rest}
            />
        );
    };

    // const CombinedField = ({ record = {} }) => 
    // {
    //     if (!record.menuRatio) return null ;
    //     const  ratio = record.menuRatio ;
    //     //console.log(ratio)
    //     return (
    //         <Card formClassName={classes.cardlayout} variant="outlined" fullWidth ="true">
    //             <CardContent>
    //             <Typography formClassName={classes.cardtitle} color="textSecondary" gutterBottom>
    //                 메뉴 구성 비율
    //             </Typography>
    //             {ratio.map(ids =>
    //                 <BoundedTextField name={"menuCategory" + ids.menuCategoryId.toString() } label={ids.menuCategoryName} defaultValue={ids.ratio} 
    //                     parse={ids => parseInt(ids)} 
    //                 />
    //             )}
    //         </CardContent>
    //         </Card>
    //     )
    // };

    const MenuRatioFields = ({ record = {} }) => 
    {
        return (
            <Card formClassName={classes.cardlayout} variant="outlined" fullWidth ="true">
                <CardContent>
                <Typography formClassName={classes.cardtitle} color="textSecondary" gutterBottom>
                    메뉴 구성 비율
                </Typography>
                <TextInput source="menuCategory1" label={record.menuCategory1Name} validate={validateNumber} formClassName={classes.inlineBlock}/>
                <TextInput source="menuCategory2" label={record.menuCategory2Name} validate={validateNumber} formClassName={classes.inlineBlock}/>
                <TextInput source="menuCategory3" label={record.menuCategory3Name} validate={validateNumber} formClassName={classes.inlineBlock}/>
                <TextInput source="menuCategory4" label={record.menuCategory4Name} validate={validateNumber} formClassName={classes.inlineBlock}/>
                <TextInput source="menuCategory5" label={record.menuCategory5Name} validate={validateNumber} formClassName={classes.inlineBlock}/>
                <TextInput source="menuCategory6" label={record.menuCategory6Name} validate={validateNumber} formClassName={classes.inlineBlock}/>
                <TextInput source="menuCategory7" label={record.menuCategory7Name} validate={validateNumber} formClassName={classes.inlineBlock}/>
                <TextInput source="menuCategory8" label={record.menuCategory8Name} validate={validateNumber} formClassName={classes.inlineBlock}/>
            </CardContent>
            </Card>
        )
    };

    return (
    <Edit {...props} transform={transformReferenceImage}>
        <TabbedForm 
          toolbar={<CustomToolbar hasEditPermission={hasEditPermission} hasDeletePermission={hasDeletePermission} />} 
          variant="outlined" 
          validate={validateOnSubmit} 
          transform={transform} >
            
            <FormTab label="고객사정보">
                <TextInput source="name" validate={validateInput} label="고객사명" formClassName={classes.inlineBlock} />
                <TextInput source="displayName" validate={validateInput} label="고객사 표시명" formClassName={classes.inlineBlock} 
                    helperText="알림 전송 등에 사용"/>
                <TextInput disabled source ="code" label="기업코드" formClassName={classes.inlineBlock}/>
                <div />
                <ReferenceInput formClassName={classes.inlineBlock} source ='typeId' label="업종" reference="commonCodes" filter={{type: '01'}}>
                    <SelectInput  optionText="desc"/>
                </ReferenceInput>
                <TextInput  source ="businessNo" label="사업자등록번호" validate={validateBiz} formClassName={classes.inlineBlock}/>
                
                {/* <ImageInput source="ciFile" label="기업로고" multiple={false} accept="image/*">
                    <ImageField source="src" title="title" />
                </ImageInput>
                <ReferenceField source="ciFile" reference="uploadedFiles" label="기업로고">
                    <ImageField source="fullPath" />
                </ReferenceField> */}
                <ReferenceImageInput 
                    label="기업로고" source="ciFile" reference="uploadedFiles" preview="fullPath" addLabel
                />
                <TextInput source ="address" label="주소" fullWidth ="true"
                  helperText="&#9888; 주소 관리는 Pinks 에서 관리 부탁드립니다"
                />
                {/* <TextInput source ="dcRate" label="주소위도" validate={validateNumber} formClassName={classes.inlineBlock}/>
                <TextInput source ="dcRate" label="주소경도" validate={validateNumber} formClassName={classes.inlineBlock}/> */}
                <TextInput source ="managerName" label="고객사 담당자"  formClassName={classes.inlineBlock} />
                <TextInput source ="managerEmail" label="고객사 담당자 이메일" validate={validateEmail} formClassName={classes.inlineBlock2}/>
                <TextInput source ="managerTelNo" label="고객사 담당자 연락처" formClassName={classes.inlineBlock}/>
                <TextInput source ="mobile" label="고객사 알림 핸드폰" formClassName={classes.inlineBlock} 
                    helperText="알림 전송 등에 사용"/>
                <div />
                <ReferenceInput validate={validateInput} formClassName={classes.inlineBlock} source ='deliveryGroupId' label="배송그룹" 
                reference="commonCodes" filter={{type: '02'}} sort={{ field: 'sort', order: 'ASC' }} perPage={100}>
                    <SelectInput  optionText="desc"/>
                </ReferenceInput>
                {/* <TextInput source ="dcRate" label="할인율" validate={validateNumber} formClassName={classes.inlineBlock}/> */}
                <TextInput source ="operationFee" label="운영비용" validate={validateNumber} formClassName={classes.inlineBlock}/>
                <BooleanInput source="fixedBcs" label="고정 운영비 적용" formClassName={classes.inlineBlock}/>
            </FormTab>

            <FormTab label="큐레이션정보">
                <ReferenceInput formClassName={classes.inlineBlock} source ='curationGroupId' label="큐레이션 그룹" reference="commonCodes" filter={{type: '12'}} perPage={200} sort={{field: 'sort', order: 'ASC'}} allowEmpty={true} >
                    <SelectInput optionText="desc"/>
                </ReferenceInput>
                <ArrayInput source="serviceTime" label="서비스타입" >
                    <SimpleFormIterator >
                        <SelectInput validate={validateChoice} formClassName={classes.arrinput} source="serviceTime" label ="조식/중식/석식" choices={[
                            { id: '0', name: '조식' },
                            { id: '1', name: '중식' },
                            { id: '2', name: '석식' },
                        ]} />
                        <ReferenceArrayInput  validate={validateChoice}
                            format={v => Array.isArray(v) ? v.map(a => a.id ? a.id: a) : []}
                            parse={ids => ids.map(id => ({id}))} 
                            source ='serviceType'  label="제공타입" fullWidth = "true" 
                            reference="commonCodes" filter={{type: '07'}} 
                            sort={{ field: 'sort', order: 'ASC' }}>
                            <CheckboxGroupInput optionText="desc" />
                        </ReferenceArrayInput>

                        <TextInput source ="timeFrom" validate={validateType} label="시작시간"  formClassName={classes.inlineBlock}/>
                        <TextInput source ="timeTo" validate={validateType} label="종료시간"  formClassName={classes.inlineBlock}/>
                        
                        <TextInput source ="price" validate={validateType} label="비용을 입력하세요"  />
                        <PricingModel />
                        {/* <Card formClassName={classes.cardlayout} variant="outlined" fullWidth ="true">
                            <CardContent>
                                <Typography formClassName={classes.cardtitle} color="textSecondary" gutterBottom>
                                    식사일 (월 ~일)
                                </Typography>
                                </CardContent>
                        </Card> */}
                        <SectionTitle>서비스 요일</SectionTitle>
                        <BooleanInput  formClassName={classes.inlineBlock} source="serviceMon" label="월" style={{ display: 'inline', float: 'left', marginLeft: '10px' }}/>
                        <BooleanInput  formClassName={classes.inlineBlock} source="serviceTue" label="화" style={{ display: 'inline', float: 'left', marginLeft: '10px' }}/>
                        <BooleanInput  formClassName={classes.inlineBlock} source="serviceWed" label="수" style={{ display: 'inline', float: 'left', marginLeft: '10px' }}/>
                        <BooleanInput  formClassName={classes.inlineBlock} source="serviceThu" label="목" style={{ display: 'inline', float: 'left', marginLeft: '10px' }}/>
                        <BooleanInput  formClassName={classes.inlineBlock} source="serviceFri" label="금" style={{ display: 'inline', float: 'left', marginLeft: '10px' }}/>
                        <BooleanInput  formClassName={classes.inlineBlock} source="serviceSat" label="토" style={{ display: 'inline', float: 'left', marginLeft: '10px' }}/>
                        <BooleanInput  formClassName={classes.inlineBlock} source="serviceSun" label="일" style={{ display: 'inline', float: 'left', marginLeft: '10px' }}/>
                            
                    </SimpleFormIterator>
                </ArrayInput>
                
                <RadioButtonGroupInput source="serviceWeek" label ="매주/격주" choices={[
                    { id: '0', name: '매주' },
                    { id: '1', name: '격주' },
                    
                ]} />
                <TextInput source="mealAvg" label="평균 취식인원" validate={validateNumber} formClassName={classes.inlineBlock}/>
                <TextInput source="mealMin" label="최소식수 (최소계약인원)" validate={validateNumber} formClassName={classes.inlineBlock}/>
                <div />
                <ReferenceInput source ="curationGenderId" fullWidth ="true" label="남녀구성비" reference="commonCodes" filter={{type: '03'}}>
                    <RadioButtonGroupInput  optionText="desc" />
                </ReferenceInput>

                <ReferenceArrayInput  
                    format={v => Array.isArray(v) ? v.map(a => a.id ? a.id: a) : []}
                    parse={ids => ids.map(id => ({id}))} 
                    source ='curationAge'  label="주요연령대" fullWidth = "true" 
                    reference="commonCodes" filter={{type: '06'}} 
                    sort={{ field: 'sort', order: 'ASC' }}>
                    <CheckboxGroupInput optionText="desc" />
                </ReferenceArrayInput>
                <MenuRatioFields />
                <RadioButtonGroupInput validate ={validateInput} source ="curation" fullWidth ="true" label="큐레이션" choices={[
                    { id: true , name: 'on' },
                    { id: false , name: 'off' },
                ]} />
              
            </FormTab>
            <FormTab label="세일즈정보">
                <ReferenceInput source ='salesStatusId' label="세일즈 상태" reference="commonCodes" filter={{type : '04'}}>
                    <SelectInput  optionText="desc"/>
                </ReferenceInput>
                <ReferenceInput source ='salesTypeId' label="기업형태 (공기업/사기업)" reference="commonCodes" filter={{type : '05'}}>
                    <SelectInput  optionText="desc"/>
                </ReferenceInput>
                <TextInput source="salesRevenue" label="월 예상 매출(원)" />
                <TextInput source="salesManager" label="세일즈 담당자" />
                <TextInput source="salesPOC" label="접점" />
                <DateInput source="salesFirstDate" label="첫 접점일자" />
                <DateInput source="salesExpectedDate" label="예상접점일자" />
                <TextInput source="salesMemo" label="비고" />   
            </FormTab>
            <FormTab label="사업자 관련정보">
                <ReferenceImageInput 
                    label="사업자등록증" source="businessRegFile" reference="uploadedFiles" preview="fullPath" addLabel
                />
                <TextInput source="invoiceBusinessNo" label="사업자등록번호" validate={maxLength(20)} />
                <TextInput source="taxRegId" label="종사업장번호" validate={maxLength(4)} />
                <SelectInput source='invoiceBusinessType' label="형태" choices={[
                    {id: 'simplified', name: '간이'},
                    {id: 'general', name: '일반'},
                    {id: 'corporate', name: '법인'}
                ]}/>
                <TextInput source="invoiceCustomerName" label="상호명" validate={maxLength(100)} />
                <TextInput source="invoiceCeoName" label="대표자명" validate={maxLength(50)}/>
                <TextInput source="invoiceEmail" label="이메일" multiline validate={maxLength(100)}/>
                <ReferenceInput source ='paymentMethodId' label="결제수단" reference="commonCodes" filter={{type : '11'}} sort={{field:'sort', order:'ASC'}}>
                    <SelectInput  optionText="desc"/>
                </ReferenceInput>
                <BooleanInput  source="taxInvoice" label="세금계산서 발행여부" />
            </FormTab>
        </TabbedForm>
    </Edit>
    )
};

const SectionTitle = styled.div`
  margin-bottom: 0.6em;
  font-size: 0.8em;
  color: rgba(0,0,0,0.54);
`;

/// 가격모델 관련 

const PricingModel = (props) => {
  const { servicePlan, price } = useRecordContext(props);
  
  return (
    <>
      <SectionTitle>
        가격 결정 모델 
      </SectionTitle>
      <PricingModelRoot>
        {servicePlan?.length > 0 ? (
          servicePlan.map((plan, i) => (
            <PricingModelItem key={i}>
              {presentPricingModel(plan, price)}
            </PricingModelItem>
          ))
        ):(
          <span>
            {presentPricingModel({ pricingModel: 'tier', tierPrice: 0 }, price)}
          </span>
        )}
      </PricingModelRoot>
    </>
  );
}

const presentPricingModel = (plan, price) => {
  if (plan.pricingModel === 'product-based') {
    return '상품 판매가';
  }
  
  const tierPrice = plan.tierPrice || price;
  return '계약단가' + (tierPrice ? `(${toPriceKRW(tierPrice)})` : '');
}

const PricingModelRoot = styled.div`
  display: flex;
  padding: 0.4em 0.8em;
  margin-bottom: 1em;
`;

const PricingModelItem = styled.div`
  margin-right: 0.8em;
  &:not(:last-child) {
    &:after {
      content: ',';
    }
  }
`;